import {INDUSTRIES_TITLES} from 'consts/industries'
import Markdown from 'utils/markdown'


import * as $utils from 'utils';
export function makePeriod(start, end){
  if (!start) return
  const f_start = $utils.format.datetime2YearMonth(start)
  const f_end = end ? $utils.format.datetime2YearMonth(end) : 'Present' 

  return `${f_start} - ${f_end}`
}

function parseMd(md){
  const parser = new Markdown()
  let html = parser.makeHTML(md)
    .replaceAll('<h5>', '<u>')
    .replaceAll('</h5>', '</u><br>')
    .replaceAll('/a><a', 'a/>&nbsp;<a')
  return html
}

function makeSectionTitle(title){
  return `
    <br>
    <h4 data-pdfmake='{"marginTop": 10, "fontSize": 14}'>${title}</h4>
  `
}

function createTable(rows, columns) {
  return `
    <table>
      ${rows.map(row => `
        <tr>
          ${columns.map(col => `<td>${row[col] || '-'}</td>`).join('')}
        </tr>
      `).join('')}
    </table>
  `
}

function createFinances({title, stats, info}) {
  let table = `
    ${makeSectionTitle(title)}
    <br>
    ${createTable(stats, ['title', 'value', 'note'])}
  `
  
  if (info) table += `<br>${parseMd(info)}`
  return table
}


function createJobs({title, jobs, education, summary}) {
  let html = makeSectionTitle(title)

  if (jobs?.length) html += `
    <br>
    <h6>Career Summary</h6>
    <br>
    ${createTable(jobs.map(x => ({...x, date: makePeriod(x.start, x.end)})), ['position', 'company', 'date'])}`

  if (education?.length) html += `
    <br>
    <h6>Educational Background</h6>
    <br>
    ${createTable(education, ['degree', 'institution', 'year'])}`

  if (summary) html += `<br>${parseMd(summary)}`

  return html
}

function createSections(sections){
  let html = ''
  for (const section of sections){
    if (section.type === 'finances') html += createFinances(section)
    else if (section.type === 'career') html += createJobs(section)
    else {
      html += `
      ${makeSectionTitle(section.title)}
      <br>
      ${parseMd(section.type === 'links' ? section.summary : section.content)}`
    }
  }
  return html
}

function removeInterpolationIndent(html){
  const regex = new RegExp(`^${String.fromCodePoint(32)}+`, 'gm')
  return html.replace(regex, '')
}
export function getCompanyTemplate(data){
  const {info, sections} = data
  let html = `<h3>${info.name}</h3>`
  if (info.hq_address) html += `<br><b>${info.hq_address}</b>`
  if (info.industry) html += `<br><b>${INDUSTRIES_TITLES[info.industry]}</b>`
  if (info.summary) html += `<br><br>${parseMd(info.summary)}`
  html += createSections(sections)
  html = removeInterpolationIndent(html)
  return html
}

export function getPersonaTemplate(data){
  const {info, sections} = data
  let html = `<h3>${info.name}</h3>`
  if (info.position) html += `<br><b>${info.position}</b>`
  if (info.company) html += `<br><b>${info.company}</b>`
  if (info.bio) html += `<br><br>${parseMd(info.bio)}`
  html += createSections(sections)
  html = removeInterpolationIndent(html)
  return html
}